import React from "react";

import settingsService from "../../services/settingsService";
import Applications from "@lms/react-applications";
import FeatureToggler from "../Feature/FeatureToggler";

const AppSwitcher = () => {
    const applicationsApiBaseAddress = settingsService.settings.applicationsApiBaseAddress;
    return (
        <FeatureToggler featureName="AppSwitcherEnabled">
            <Applications
                uri={applicationsApiBaseAddress}
                userType={"LawFirm"}
            />
        </FeatureToggler>
    );
};

export default AppSwitcher;